<template>
  <path
    d="M4.24999 5.61018C6.56999 8.59018 9.99999 13.0002 9.99999 13.0002V18.0002C9.99999 19.1002 10.9 20.0002 12 20.0002C13.1 20.0002 14 19.1002 14 18.0002V13.0002C14 13.0002 17.43 8.59018 19.75 5.61018C20.26 4.95018 19.79 4.00018 18.95 4.00018H5.03999C4.20999 4.00018 3.73999 4.95018 4.24999 5.61018Z"
  />
</template>
